import { IPostOneImageUploadRequest } from "../../../interfaces/api/IMedia";

export default class PostOneImageUploadRequest implements IPostOneImageUploadRequest {
    image: File;
    description: string;

    constructor(data: IPostOneImageUploadRequest) {
        this.image = data.image;
        this.description = data.description;
    }
}